import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { stockEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  detailLotNo: [],
  stockLotNo: []
}


const stockEntrySlice = createSlice({
  name: stockEntry,
  initialState,
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
    setDetailLotno: (state, action) => {
      console.log(action.payload)
      state.detailLotNo = action.payload
    },
     setStockLotno: (state, action) => {
      console.log(action.payload)
      state.stockLotNo = action.payload
    }
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode, setDetailLotno,setStockLotno} = stockEntrySlice.actions
export default stockEntrySlice.reducer
